import React from 'react';
import { useSelector } from 'react-redux';

import { GTMTracking } from '@common/ui/general';
import { toast } from '@common/ui/general/Toast';

import ACSConnectSuccess from '@alumni_v2/ui/SidebarModal/ACSConnectSuccess';
import TodosBeforeSession from '@alumni_v2/ui/SidebarModal/TodosBeforeSession';

import ClipboardTextIcon from '@alumni_v2/images/svg/ClipboardText.svg';
import ClockIcon from '@alumni_v2/images/svg/Clock.svg';
import WarningIcon from '@alumni_v2/images/svg/Warning.svg';

import styles from './SETContent.module.scss';

const listItems = [
  {
    icon: ClipboardTextIcon,
    text: '13 Questions',
  },
  {
    icon: ClockIcon,
    text: '30 Minutes',
  },
  {
    icon: WarningIcon,
    text: '3 Attempts left',
  },
];


const ListComp = () => listItems.map(listItem => (
  <div key={listItem.text} className={styles.list}>
    <div className={styles.item}>
      <img src={listItem.icon} alt="" />
      <div>{listItem.text}</div>
    </div>
  </div>
));

const onSETClick = (product, onModalClose) => {
  toast.show({
    message: 'Redirecting...',
    type: 'success',
    duration: 5000,
  });

  const productLink = product === 'academy' ? 'academy' : 'data-science-course';
  window.open(`/${productLink}/test`, '_blank');
  onModalClose();
};


const SETButton = ({ product, onModalClose }) => (
  <GTMTracking
    component="button"
    gtmEventType="cta"
    gtmEventAction="click"
    gtmEventResult="acs_set_modal_button_clicked"
    gtmEventCategory="alumni_directory"
    className={styles.button}
    onClick={() => onSETClick(product, onModalClose)}
    tabIndex={-1}
    role="button"
    gtmEventData={{
      click_type: 'acs_set_modal_button_clicked',
      click_text: 'Take Entrance Test',
      click_section: 'card_details',
    }}
  >
    Take Entrance Test
  </GTMTracking>
);

const SETContent = ({ onModalClose }) => {
  const product = useSelector((state) => state.reviews.product);

  return (
    <>
      <ACSConnectSuccess context="intermediate_stage" />
      <TodosBeforeSession
        heading="Discover your strengths in Logic, Aptitude, Maths, and Coding!"
        description="Take the Scaler Entrance Test and get
      ready for your upcoming Alumni Session. "
        listComp={<ListComp />}
      />
      <SETButton product={product} onModalClose={onModalClose} />
    </>
  );
};

export default SETContent;
